<div class="conversation-input-container">
  @if (shouldShowFilters) {
    <app-conversation-filters
      [visible]="filtersAreOpened"
      [anchor]="filtersAnchor"
      [bot]="bot"
      (filterChange)="handleFilterChange($event)"
    ></app-conversation-filters>
  }
  <div>
    <form class="conversation-input-form" (ngSubmit)="submit()" [formGroup]="messagesForm">
      <div #filtersAnchor #promptHintsAnchor class="message">
        <div [class.is-focussed]="isInputFocused" class="message--content">
          <!-- Show selected sources when they exist (for "Add as sources" option) -->
          @if (selectedSources.length > 0) {
            <div class="message--attachments">
              @for (source of selectedSources; track source) {
                <div class="source-item">
                  <span class="source-name">{{ source.name }}</span>
                  <mat-icon (click)="removeSource(source)">close</mat-icon>
                </div>
              }
            </div>
          }
          <div class="message--input padding">
            <!-- Dropzones Container (show if input1 or input2 are configured) -->
            @if (hasInput1() || hasInput2()) {
              <div class="dropzones-row">
                <!-- Left Dropzone (input1) -->
                @if (hasInput1()) {
                  <div
                    class="visible-dropzone"
                    [class.has-files]="filesInput1.length > 0"
                    [class.dragging]="isDraggingInput1"
                    (dragenter)="handleDragEnter($event, 'input1')"
                    (dragover)="handleDragOver($event)"
                    (dragleave)="handleDragLeave($event, 'input1')"
                    (drop)="onDropFiles($event, 'input1')"
                    >
                    @if (filesInput1.length === 0) {
                      <div class="dropzone-empty-state">
                        <mat-icon class="dropzone-icon">cloud_upload</mat-icon>
                        @if (getField('input1')?.description) {
                          <p class="dropzone-description">
                            {{ getField('input1')?.description }}
                          </p>
                        }
                        <p class="dropzone-text">
                          Drop files or
                          <span class="browse-link" (click)="fileInputInput1.click()">browse</span>
                        </p>
                      </div>
                    }
                    @if (filesInput1.length > 0) {
                      <div class="dropzone-files-grid">
                        @for (file of filesInput1; track file; let i = $index) {
                          <div class="file-chip">
                            <mat-icon class="file-icon">insert_drive_file</mat-icon>
                            <span class="file-name">{{ file.name }}</span>
                            <button
                              type="button"
                              class="remove-file-btn"
                              (click)="removeFieldFile(i, 'input1')"
                              >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        }
                      </div>
                    }
                    @if (
                      filesInput1.length > 0 &&
                      filesInput1.length < (getField('input1')?.maxFiles || 5)
                      ) {
                      <button
                        type="button"
                        class="add-more-files-btn"
                        (click)="fileInputInput1.click()"
                        >
                        <mat-icon>add</mat-icon>
                        Add more
                      </button>
                    }
                  </div>
                }
                <!-- Right Dropzone (input2) -->
                @if (hasInput2()) {
                  <div
                    class="visible-dropzone"
                    [class.has-files]="filesInput2.length > 0"
                    [class.dragging]="isDraggingInput2"
                    [class.disabled]="isInput2Disabled()"
                    (dragenter)="handleDragEnter($event, 'input2')"
                    (dragover)="handleDragOver($event)"
                    (dragleave)="handleDragLeave($event, 'input2')"
                    (drop)="onDropFiles($event, 'input2')"
                    >
                    @if (filesInput2.length === 0) {
                      <div class="dropzone-empty-state">
                        <mat-icon class="dropzone-icon">cloud_upload</mat-icon>
                        @if (getField('input2')?.description) {
                          <p class="dropzone-description">
                            {{ getField('input2')?.description }}
                          </p>
                        }
                        @if (!isInput2Disabled()) {
                          <p class="dropzone-text">
                            Drop files or
                            <span class="browse-link" (click)="fileInputInput2.click()">browse</span>
                          </p>
                        }
                        @if (isInput2Disabled()) {
                          <p class="dropzone-text dropzone-disabled-hint">
                            Add files to first field first
                          </p>
                        }
                      </div>
                    }
                    @if (filesInput2.length > 0) {
                      <div class="dropzone-files-grid">
                        @for (file of filesInput2; track file; let i = $index) {
                          <div class="file-chip">
                            <mat-icon class="file-icon">insert_drive_file</mat-icon>
                            <span class="file-name">{{ file.name }}</span>
                            <button
                              type="button"
                              class="remove-file-btn"
                              (click)="removeFieldFile(i, 'input2')"
                              >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        }
                      </div>
                    }
                    @if (
                      filesInput2.length > 0 &&
                      filesInput2.length < (getField('input2')?.maxFiles || 5)
                      ) {
                      <button
                        type="button"
                        class="add-more-files-btn"
                        (click)="fileInputInput2.click()"
                        >
                        <mat-icon>add</mat-icon>
                        Add more
                      </button>
                    }
                  </div>
                }
              </div>
            }

            <!-- Textarea (show if textarea is configured) -->
            @if (hasTextarea()) {
              <div class="w-full">
                <div
                  (dragenter)="handleDragEnter($event)"
                  (dragover)="handleDragOver($event)"
                  (dragleave)="handleDragLeave($event)"
                  (drop)="onDropFiles($event)"
                  [class.drag-over]="isDragging"
                  >
                  <textarea
                    (blur)="onInputBlur()"
                    (focus)="onInputFocus()"
                    (keydown)="onKeyDown($event)"
                    [placeholder]="getField('textarea')?.description || placeholder"
                    cdkTextareaAutosize
                    formControlName="message"
                    class="message-input"
                    [cdkAutosizeMinRows]="1"
                    [cdkAutosizeMaxRows]="6"
                  ></textarea>
                </div>
              </div>
            }
            <div class="message--actions">
              <!-- Action buttons - only show if textarea exists -->
              @if (hasTextarea()) {
                <div class="message--action-buttons">
                  @if (shouldShowFilters) {
                    <app-custom-button
                      icon="tune"
                      tooltip="Toggle filters"
                      [active]="filtersAreOpened"
                      (buttonClick)="toggleFilters()"
                    ></app-custom-button>
                  }
                  @if (hasAssistantMessages() && isTalkingAvatarActive()) {
                    <app-custom-button
                      icon="record_voice_over"
                      tooltip="Read conversation aloud"
                      (buttonClick)="readConversationAloud()"
                    ></app-custom-button>
                  }
                  @if (getField('textarea')?.showSourceSelector) {
                    <app-custom-button
                      icon="source"
                      tooltip="Add from sources"
                      (buttonClick)="openSourceSearch()"
                    ></app-custom-button>
                  }
                  @if (getField('textarea')?.showUpload) {
                    <app-custom-button
                      icon="attach_file"
                      tooltip="Attach up to 5 files"
                      (buttonClick)="handleAttachButtonClick()"
                    ></app-custom-button>
                  }
                  <!-- Keywords quick actions -->
                  @if (getField('textarea')?.showFolderKeywords && shouldShowKeywords) {
                    <div
                      class="keywords-container"
                      >
                      @for (keyword of getKeywordsToDisplay(); track keyword) {
                        <div
                          class="keyword-chip"
                          [class.active]="isKeywordActive(keyword)"
                          (click)="onKeywordClick(keyword)"
                          [title]="'Click to toggle keyword: ' + keyword.displayText"
                          >
                          <mat-icon class="keyword-icon">
                            {{ isKeywordActive(keyword) ? 'check_circle' : 'radio_button_unchecked' }}
                          </mat-icon>
                          <span>{{ keyword.displayText }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              <!-- Avatar talking disclaimer -->
              @if (showAvatarDisclaimer()) {
                <div class="avatar-disclaimer">
                  <mat-icon class="disclaimer-icon">info</mat-icon>
                  <span class="disclaimer-text"
                    >Avatar is talking - please wait before saving files</span
                    >
                  </div>
                }

                <!-- Send area - always show -->
                <div class="message--send-area">
                  <div class="send-area-left">
                    <!-- Agent name display (when bot is selected) -->
                    @if (bot) {
                      <div class="agent-name-display">
                        <span class="agent-label">Agent:</span>
                        <span class="agent-name">{{ bot.name }}</span>
                      </div>
                    }

                    <!-- Always show talking avatar toggle if textarea exists -->
                    @if (hasTextarea()) {
                      <app-talking-avatar-toggle
                        [bot]="bot"
                      ></app-talking-avatar-toggle>
                    }

                    @if (hasTextarea()) {
                      <app-speech-recognition
                        (finished)="setPlaceholder()"
                        (started)="setPlaceholder('Listening...')"
                        (transcription)="updateMessage($event)"
                        [hidden]="!(messagesForm.get('message')?.value === '' && !isWriting)"
                        [language]="'en-US'"
                        class="speech-recognition-btn"
                      ></app-speech-recognition>
                    }
                  </div>

                  <div class="send-area-right">
                    <!-- Submit button - always show -->
                    @if (!isWriting) {
                      <app-custom-button
                        icon="send"
                        [tooltip]="getSubmitButtonTooltip()"
                        [active]="canSubmit()"
                        [disabled]="!canSubmit()"
                        (buttonClick)="submit()"
                      ></app-custom-button>
                    }

                    @if (isWriting) {
                      <app-custom-button
                        icon="stop"
                        tooltip="Stop generation"
                        (buttonClick)="writingAbort.emit()"
                      ></app-custom-button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Prompt hints dropdown: shown before conversation starts -->
        @if (shouldShowPromptHintsDropdown) {
          <app-prompt-hints-dropdown
            [anchor]="promptHintsAnchor"
            [promptHints]="getEffectivePromptHints()"
            [isVisible]="isInputFocused && hasPromptHints"
            [selectedIndex]="selectedHintIndex"
            (hintSelected)="selectPromptHint($event)"
            (selectedIndexChange)="selectedHintIndex = $event"
          ></app-prompt-hints-dropdown>
        }

        <input #fileInput (change)="onFileSelected($event)" hidden multiple type="file" />
        <input
          #fileInputInput1
          (change)="onFileSelectedForField($event, 'input1')"
          hidden
          multiple
          type="file"
          />
        <input
          #fileInputInput2
          (change)="onFileSelectedForField($event, 'input2')"
          hidden
          multiple
          type="file"
          />
      </form>
    </div>
  </div>
